import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {Housing} from '@guestapp/sdk';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';

type OptionsProps = UseQueryOptions<Housing, Error>;

function useFetchHousing(housingId?: string, options?: OptionsProps) {
  const {getHousing} = useChekinSDK();
  return useQuery<Housing, Error>(
    [QUERY_CACHE_KEYS.housing],
    () => getHousing(housingId || ''),
    options,
  );
}

export {useFetchHousing};
